import React from 'react';
import cn from 'classnames';

import styles from './MessageSectionMarker.module.scss';

export type MessageSectionMarkerProps = {
  className?: string;
  title: string;
};

const MessageSectionMarker: React.FC<MessageSectionMarkerProps> = ({
  className,
  title
}) => {
  return (
    <div className={cn(styles['section-marker'], className)}>
      <div className={styles['section-marker__title']}>{title}</div>
    </div>
  );
};

export default MessageSectionMarker;
